import { render, staticRenderFns } from "./ubigeo.vue?vue&type=template&id=6c6d2a6a"
import script from "./ubigeo.vue?vue&type=script&lang=ts"
export * from "./ubigeo.vue?vue&type=script&lang=ts"
import style0 from "./ubigeo.vue?vue&type=style&index=0&id=6c6d2a6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports